import { gql } from "@apollo/client";

export const createUserMutation = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      id
      email
      disabled
      name
      permissions
    }
  }
`;

export const updateUserMutation = gql`
  mutation UpdateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
      email
      disabled
      name
      permissions
    }
  }
`;

export const deleteUserMutation = gql`
  mutation DeleteUser($userId: Float!) {
    deleteUser(userId: $userId)
  }
`;

export const enableUserMutation = gql`
  mutation EnableUser($userId: Float!) {
    enableUser(userId: $userId)
  }
`;

export const disableUserMutation = gql`
  mutation DisableUser($userId: Float!) {
    disableUser(userId: $userId)
  }
`;
